import { render, staticRenderFns } from "./ProxySettingsModal.vue?vue&type=template&id=4b48008a&scoped=true"
import script from "./ProxySettingsModal.vue?vue&type=script&lang=js"
export * from "./ProxySettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48008a",
  null
  
)

export default component.exports